import { createFileRoute } from "@tanstack/react-router"
import { TenantRoute } from "@/tenant"

export const Route = createFileRoute("/(user)/(tenant)")({
  component: RouteComponent,
})

function RouteComponent() {
  return <TenantRoute tenantSlug={undefined} />
}
